import React from 'react';
import { Link } from 'react-router-dom';
import SectionBackground from './SectionBackground';

// Illustrative Brazil Watch alert, drawn as a screen of the TM RUSH system.
export const WatchAlertMock = ({ className = '' }) => (
  <div className={className} aria-label="Illustrative example of a TM RUSH Brazil Watch alert">
    <div className="rounded-3xl p-2 bg-white/10 border border-white/20 backdrop-blur-sm shadow-2xl">
      <div className="bg-white text-text rounded-2xl overflow-hidden">
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-gray-100">
          <img src="/images/tm-rushlogo.svg" alt="TM RUSH" className="h-5 w-auto" />
          <span className="text-[11px] font-semibold uppercase tracking-wider text-primary-dark bg-primary/10 px-2.5 py-1 rounded-full">
            Brazil Watch
          </span>
        </div>
        <div className="px-5 pt-4 pb-5">
          <div className="flex items-center justify-between gap-3 mb-3">
            <span className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-500" aria-hidden="true" />
              Possible conflict
            </span>
            <span className="text-xs text-text/50 whitespace-nowrap">
              <span className="hidden sm:inline">Weekly gazette · </span>Tuesday
            </span>
          </div>
          <p className="font-semibold leading-snug mb-4">A similar mark was just published in Brazil, in your class</p>
          <div className="grid grid-cols-2 gap-2.5 mb-4">
            <div className="bg-primary/10 rounded-xl px-3 py-2.5">
              <div className="text-[10px] font-semibold uppercase tracking-wide text-primary-dark">Your mark</div>
              <div className="text-lg font-bold leading-tight">NORDA</div>
              <div className="text-[11px] text-text/60">Class 3</div>
            </div>
            <div className="bg-amber-50 rounded-xl px-3 py-2.5">
              <div className="text-[10px] font-semibold uppercase tracking-wide text-amber-800">New filing</div>
              <div className="text-lg font-bold leading-tight">NORDAH</div>
              <div className="text-[11px] text-text/60">Class 3 · third party</div>
            </div>
          </div>
          <div className="flex items-end justify-between gap-3">
            <div>
              <div className="text-[10px] font-semibold uppercase tracking-wide text-text/50 whitespace-nowrap">Time to oppose</div>
              <div className="text-xl sm:text-2xl font-bold leading-tight whitespace-nowrap">60 days</div>
            </div>
            <span className="bg-text text-white text-xs sm:text-sm font-semibold rounded-lg px-3 sm:px-4 py-2 whitespace-nowrap">Review and decide</span>
          </div>
        </div>
        <div className="flex items-center gap-2 px-5 py-2.5 bg-background-auxiliary text-[11px] text-text/70">
          <span className="text-primary font-bold" aria-hidden="true">✓</span>
          Checked against every new filing in this week's gazette
        </div>
      </div>
    </div>
    <p className="text-[11px] text-white/60 text-center mt-2">Illustrative example.</p>
  </div>
);

const BrazilWatchBand = () => (
  <div className="container mx-auto px-4 pb-10 md:pb-14">
    <SectionBackground image="/images/bg-hero.svg" overlay="dark" rounded className="shadow-lg">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center p-6 md:p-12">
        <div className="lg:col-span-7 text-white">
          <p className="text-primary-light font-semibold text-sm uppercase tracking-wider mb-3">
            New · Brazil Trademark Watch
          </p>
          <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
            Would you know if someone filed your brand in Brazil this week?
          </h2>
          <p className="text-gray-200 text-lg leading-relaxed mb-7 max-w-2xl">
            Brazil publishes every new trademark application in a weekly gazette, in Portuguese. We read it every
            Tuesday and alert you while there is still time to oppose.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <Link
              to="/brazil-watch"
              className="inline-block bg-primary text-white px-7 py-3 rounded-xl hover:bg-primary-hover font-semibold shadow-md"
            >
              See Brazil Watch
            </Link>
            <span className="inline-block bg-white/10 border border-white/20 backdrop-blur-sm text-gray-200 text-sm px-4 py-2 rounded-xl">
              US$ 150 per mark / year · 12 months included with every filing
            </span>
          </div>
        </div>
        <WatchAlertMock className="lg:col-span-5 w-full max-w-md mx-auto lg:max-w-none" />
      </div>
    </SectionBackground>
  </div>
);

export default BrazilWatchBand;
